import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootLayoutComponent } from './shared/layout/root-layout/root-layout.component';
import { BaseGuard } from './shared/guards/base.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { OptOutComponent } from './opt-out/opt-out.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { UpgradeRedirectionComponent } from './pages/upgrade-redirection/upgrade-redirection.component';
import { PayInvoiceComponent } from './pay-invoice/pay-invoice.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [BaseGuard],
  },
  {
    path: 'signup-share',
    loadChildren: ()=> import('./shares/shares.module').then(m=>m.SharesModule),
  },
  {
    path: '',
    component: RootLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'settings',
        pathMatch: 'full'
      },
      {
        path: 'users',
        loadChildren: () => import('./users-roles/users-roles.module').then(m => m.UsersRolesModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'settings',
        title: 'Settings | Sync.com',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'files',
        title: 'Files | Sync.com',
        loadChildren: () => import('./file-list/file-list.module').then(m => m.FileListModule),
        data: { defaultSyncIdKey: 'syncus_sync_id' },
        canActivate: [AuthGuard]
      },
      {
        path: 'files/:sync_id',
        data: { defaultSyncIdKey: 'syncus_sync_id' },
        loadChildren: () => import('./file-list/file-list.module').then(m => m.FileListModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'file',
        loadChildren: ()=> import('./file/file.module').then(m=>m.FileModule),
      },
      {
        path: 'recents',
        title: 'Recents | Sync.com',
        loadChildren: () => import('./recents/recents.module').then(m => m.RecentsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'vault',
        title: 'Vault | Sync.com',
        loadChildren: () => import('./file-list/file-list.module').then(m => m.FileListModule),
        data: { defaultSyncIdKey: 'web_sync_id' },
        canActivate: [AuthGuard]
      },
      {
        path: 'vault/:sync_id',
        data: { defaultSyncIdKey: 'web_sync_id' },
        loadChildren: () => import('./file-list/file-list.module').then(m => m.FileListModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'shares',
        title: 'Shares | Sync.com',
        loadChildren: ()=> import('./shares/shares.module').then(m=>m.SharesModule),
      },
      {
        path: 'starred',
        title: 'Starred | Sync.com',
        loadChildren: () => import('./starred/starred.module').then(m => m.StarredModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'starred/:sync_id',
        loadChildren: () => import('./file-list/file-list.module').then(m => m.FileListModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'file-history',
        title: 'Version History | Sync.com',
        loadChildren: ()=> import('./file/file.module').then(m=>m.FileModule),
      },
      {
        path: 'files/file-history',
        title: 'Version History | Sync.com',
        loadChildren: ()=> import('./file/file.module').then(m=>m.FileModule),
      },
      {
        path: 'vault/file-history',
        title: 'Version History | Sync.com',
        loadChildren: ()=> import('./file/file.module').then(m=>m.FileModule),
      },
      {
        path: 'opt-out',
        component: OptOutComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'pay-invoices',
        component:PayInvoiceComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  { 
    path: 'account/upgrade',
    component: UpgradeRedirectionComponent
  },

  {
    path: 'dl',
    loadChildren: () => import('./link-consume/link-consume.module').then(m => m.LinkConsumeModule)
  },
  {
    path: 'dl/:cachekey',
    loadChildren: () => import('./link-consume/link-consume.module').then(m => m.LinkConsumeModule)
  },
  {
    path: 'dl/:cachekey/view/:type/:id',
    loadChildren: () => import('./link-consume/link-consume.module').then(m => m.LinkConsumeModule)
  },
  {
    path: 'comment-iframe',
    loadChildren: () => import('./link-consume/link-consume.module').then(m => m.LinkConsumeModule)
  },
  // legacy routes
  { path: 'links', redirectTo: 'shares/links' },
  { // <-- Always last
    path: '**',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
